import React, { Fragment } from 'react';
import { BANNER_WIDGET_LAYOUT_TYPE_V2, BannerWidgetDetailV2 } from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import notFoundImg from '../../../../../../../static/images/common/not-found-img.png';
import { BannerWidgetScrollLayoutStyle } from './style';

export type BannerWidgetScrollLayoutDetail = BannerWidgetDetailV2 & {
  layoutType: typeof BANNER_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1;
};

interface BannerWidgetScrollLayoutProps {
  detail: BannerWidgetScrollLayoutDetail;
}

const BannerWidgetScrollLayout = (props: BannerWidgetScrollLayoutProps) => {
  const { detail } = props;

  return (
    <BannerWidgetScrollLayoutStyle>
      {detail.widgetItemBanners?.map((eventSection, index) => {
        const image = eventSection.mobileImage?.[0];

        return (
          <div key={index} className="widget-banner-section">
            <Img clickAble={false} src={image?.url || notFoundImg} />

            <Fragment>
              <div className="title">
                {eventSection.title || <span className="require-info">배너 섹션 타이틀을 설정해주세요.</span>}
              </div>

              {eventSection.contents ? <div className="contents">{eventSection.contents}</div> : null}
            </Fragment>
          </div>
        );
      })}
    </BannerWidgetScrollLayoutStyle>
  );
};

export default BannerWidgetScrollLayout;
